var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharableLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03101 6.174C0.989338 6.06174 0.989338 5.93825 1.03101 5.826C1.43686 4.84192 2.12577 4.00052 3.01039 3.40845C3.89502 2.81638 4.93553 2.50031 6.00001 2.50031C7.06449 2.50031 8.105 2.81638 8.98962 3.40845C9.87425 4.00052 10.5632 4.84192 10.969 5.826C11.0107 5.93825 11.0107 6.06174 10.969 6.174C10.5632 7.15807 9.87425 7.99948 8.98962 8.59155C8.105 9.18362 7.06449 9.49969 6.00001 9.49969C4.93553 9.49969 3.89502 9.18362 3.01039 8.59155C2.12577 7.99948 1.43686 7.15807 1.03101 6.174Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.5C6.82843 7.5 7.5 6.82843 7.5 6C7.5 5.17157 6.82843 4.5 6 4.5C5.17157 4.5 4.5 5.17157 4.5 6C4.5 6.82843 5.17157 7.5 6 7.5Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharableLink);
export default __webpack_public_path__ + "static/media/sharable-link.c4eca5a1a2d01b32a54c30691dc7841b.svg";
export { ForwardRef as ReactComponent };